import * as React from 'react';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n, isAuth } from 'arm-common';
import FondiAction from './fondi_action'
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { AppConstants } from '../../constants/AppConstants';
import { resolve } from 'path';
import { reject } from 'lodash';

class FondiList extends React.Component {
    constructor(props) {
        super(props);
        this.createFondi = this.createFondi.bind(this);
        this.componentName = '[FondiList.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [
            { field: 'fonId', title: 'Id', sortable: 'true' },
            // { field: 'fonCategoria', title: i18n('ARM_CORE_PRODUCT.MANAGE.CATEGORIA', 'Categoria') },
            { field: 'fonDescrizione', title: i18n('ARM_CORE_PRODUCT.MANAGE.DESCRIZIONE', 'Descrizione') },
            { field: 'fonCodBanca', title: i18n('ARM_CORE_PRODUCT.MANAGE.CODICE_BANCA', 'Codice Banca') },
            { field: 'fonIsin', title: i18n('ARM_CORE_PRODUCT.MANAGE.CODICE_ISIN', 'Codice Isin') },
            { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Update'), visible: false, formatter: this.dataFormat },
            { field: 'info', title: 'Dettagli', formatter: this.columnDetail, visible: this.props.showInfoColumn }

        ];


        $(this.refs.fondiTable).bootstrapTable({
            columns: columns,
            idField: "fonId",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        this.props.getListaFondi();
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.fondiList !== this.props.fondiList) {
            console.log("\t rows: " + (nextProps.fondiList !== null ? nextProps.fondiList.length : "NULL"));
            $(this.refs.fondiTable).bootstrapTable('load', nextProps.fondiList);
            console.log(this.componentName + ' fondiList');
        }
    }

    dataFormat(value, row, index) {
        if (value === "0") {
            return "-";
        }
        return DateFormatter.dataFormatter(value);
    }
    columnDetail(value, row, index) {
        console.log(this.componentName + " columnDetail: " + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm' href='#/fondi/details'><i class='fas fa-info fa-fw' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + " deatilsOnClick: " + row.fonId);
        let fonId = row.fonId;
        if (field === "info") {
            this.props.getFondoDetails(fonId).then(
                resolve => {
                    if (fonId !== null || fonId !== undefined || fonId !== '') {
                        console.log(this.componentName + "ok id esiste" + fonId)
                        this.props.history.push({ pathname: '/fondi/details', state: { fonId: row.fonId } });

                    }
                    return resolve
                },
                reject => {
                    console.log(this.componentName + ' KO');
                }
            )


        }

    }
    //prima fondo poi push senza state

    createFondi() {
        this.props.history.push('/fondi/create');
        this.props.clearAll();
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card">
                <div className="card-header">
                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                        <agui.aButton className="float-right" bs='primary' onClick={this.createFondi} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVA', 'Nuovo')} </agui.aButton>
                    }
                    <h3>{i18n('ARM_CORE_PRODUCT.MENUTOP.FONDI', 'Fondi')}</h3>
                </div>
                <div className="card-body">

                    <table ref="fondiTable" className={AppConstants.CLASS_TABLE} />
                </div>
            </div>
        );
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getListaFondi() {
            return dispatch(FondiAction.getListaFondi());
        },
        clearAll() {
            return dispatch(FondiAction.clearAll());
        },
        getFondoDetails(fonId) {
            return dispatch(FondiAction.getFondoDetails(fonId));
        }
    }
}


function mapStateToProps(state) {
    return {
        fondiList: state.fondi.listFondi
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FondiList);